import { toast } from "react-toastify";
import { createSlice } from '@reduxjs/toolkit';
import InsurerService from "../../services/InsurerService";
import { APIResponse } from '../../store/types/Common';
import { STATUS_SUCCESS } from "@src/config/constant";


const Insurer = createSlice({
    name: 'insurer',
    initialState: {
        insurer: {}
    },
    reducers: {
        insurerListing: (state, action) => {
            state.insurer = action.payload
        }
    }
})

export default Insurer.reducer;

const { insurerListing } = Insurer.actions


/**
 * Function to make API call to fetch partner mapping listing
 * @param params 
 * @returns 
 */
export const getInsurerList = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsurerService.getInsurerListData(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                        resolve(response.data)
                        dispatch(insurerListing(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


/**
 * Function to make API call to update Insurance Partner Mappings
 * @param params 
 * @returns 
 */
export const editInsurer = (params: any) => {
    return new Promise((resolve, reject) => {
        InsurerService.editInsurer(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const addInsurer = (params: object) => {
    return new Promise((resolve, reject) => {
        InsurerService.addInsurer(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}



export const updateInsurerStatus = (params: object) => {
    return new Promise((resolve, reject) => {
        InsurerService.updateInsurerStatus(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}



